import _ from "lodash";
import { computed } from "mobx";
import { useMemo } from "react";
import { useLeaseCompStore, usePipedriveStore } from "..";

export default function (ownerFilter: string, searchFilter: string, sortBy: string) {
    const leaseCompStore = useLeaseCompStore();
    const pipedriveStore = usePipedriveStore();

    const ownerFilteredLeaseComps = useMemo(() => computed(() => {
        switch (ownerFilter) {
            case "All Owners":
                return leaseCompStore.leaseComps;
            case "None":
                return leaseCompStore.leaseComps.filter(lc => !lc.modifiedByUser);
            default:
                return leaseCompStore.leaseComps.filter(lc => lc.modifiedByUser === ownerFilter);
        }
    }), [ownerFilter]).get();

    const sortedLeaseComps = useMemo(() => {
        switch (sortBy) {
            case LeaseCompsSortingType.ModifiedNewest:
                return _.orderBy(ownerFilteredLeaseComps, leaseComp => leaseComp.modifiedDate, "desc");
            case LeaseCompsSortingType.ModifiedOldest:
                return _.orderBy(ownerFilteredLeaseComps, leaseComp => leaseComp.modifiedDate, "asc");
            default:
                return _.orderBy(ownerFilteredLeaseComps, leaseComp => leaseComp.modifiedDate, "asc");
        }
    }, [ownerFilteredLeaseComps, sortBy]);

    return useMemo(() => {
        if (!searchFilter)
            return sortedLeaseComps;

        const searchFilterInLowerCase = searchFilter.toLowerCase();

        return sortedLeaseComps.filter(lc =>
            (lc.address && lc.address.toLowerCase().includes(searchFilterInLowerCase)) ||
            (lc.zoning && lc.zoning.toLowerCase().includes(searchFilterInLowerCase)) ||
            (lc.notes && lc.notes.toLowerCase().includes(searchFilterInLowerCase)) ||
            (lc.pipedriveCompanyId && pipedriveStore.organizations.find(o => o.id === lc.pipedriveCompanyId)?.name.toLowerCase().includes(searchFilterInLowerCase))
        );
    }, [sortedLeaseComps, searchFilter]);
}

export class LeaseCompsSortingType {
    static ModifiedNewest = "ModifiedNewest";
    static ModifiedOldest = "ModifiedOldest";
}